<!-- Head and Meta component for managing the document head and meta tags
     Sets the page title, description, and other meta attributes based on the current route -->

<template>
  <div />
</template>
<script setup lang="ts">
import site from "@/site"; // Import site configuration
import { getOrganization } from "~/lib/config/host";

const route = useRoute(); // Get the current route

// Destructure site properties
const { description, author } = site;
let { name } = site;

const organization = getOrganization();

name = name.replace("HYP", organization);

const logo = computed(() => {
  return useRewardsStore().getLogo();
});

// Computed property for the page title
const title = computed(() => route.meta.title);

// Computed property for the full title including site name
const theTitle = computed(() =>
  title.value ? `${title.value} - ${name}` : name,
);

// Computed property for the page description
const theDescription = computed(
  () => (route.meta.description || description) as string,
);

// Get the current theme class name
const themeClassName = useNuxtApp().$vuetify.theme.global.name;

// Set the document head properties
watch(
  logo,
  () => {
    useHead({
      title: theTitle,
      htmlAttrs: { lang: "en-US", class: themeClassName },
      link: [
        {
          rel: "icon",
          type: "image/x-icon",
          href: logo.value,
        },
      ],
    });
  },
  { immediate: true },
);

// Set server-side SEO meta properties
useServerSeoMeta({
  author,
  description: theDescription,
});
</script>
